import React               from 'react';
import Alert               from '../../shared/alert';
import LoaderButton        from '../../shared/loader-button/loader-button.jsx';
import PasswordInput       from '../../shared/password-input/password-input.jsx';
import PasswordHelper      from '../../shared/password-helper-input/password-helper.jsx';
import LanguageSelector    from '../../shared/language-selector/language-selector.jsx';
import { CloseCircleIcon } from '../../shared/icons/icons.jsx';
import LocaleString        from '../../shared/locale-string';
import Back                from '../../shared/back';
import describedByString   from '../../../utils/describedby-string';

import './profile.scss';


class Profile extends React.Component {

    resetLocaleFocus = false;
    resetPwdFocus = false;

    state = {
        oldPassword: '',
        newPassword: '',
        locale: 'en-US'
    };

    UNSAFE_componentWillReceiveProps( nextProps ) {//eslint-disable-line
        if ( !this.props.passwordChangeSuccess && nextProps.passwordChangeSuccess ) {
            this.clearPwdInputs();
        }
    }

    UNSAFE_componentWillMount() {//eslint-disable-line
        this.props.dismissAllErrors();
        this.props.dismissSuccess();
    }

    componentWillUnmount() {
        this.props.dismissAllErrors();
        this.props.dismissSuccess();
    }

    UNSAFE_componentWillUpdate( nextProps ) {//eslint-disable-line
        const oldPwdErrLength    = this.props.changePwdErrors.length;
        const oldLocaleErrLength = this.props.changeLocaleErrors.length;
        const newPwdErrLength    = nextProps.changePwdErrors.length;
        const newLocaleErrLength = nextProps.changeLocaleErrors.length;

        this.resetPwdFocus    = ( newPwdErrLength > oldPwdErrLength );
        this.resetLocaleFocus = ( newLocaleErrLength > oldLocaleErrLength );
    }

    componentDidUpdate() {
        if ( this.resetPwdFocus ) {
            const input = document.getElementById( 'oldPassword' );
            input.focus();
            input.select();
        }

        if ( this.resetLocaleFocus ) {
            this.langSelect.focus();
        }
    }

    clearPwdInputs = () => {
        this.setState( { oldPassword: '', newPassword: '' } );
    };

    handleInputChange = event => {
        const name = event.target.name;
        if ( this.props.passwordChangeSuccess === true ) {
            this.props.dismissSuccess();
        }
        this.setState( { [ name ]: event.target.value } );
    };

    handleChangePassword = ( oldPassword, newPassword ) => {
        this.props.changePassword( oldPassword, newPassword );
    };

    validatePasswordFields = () => {
        const { oldPassword, newPassword } = this.state;
        return oldPassword.length && newPassword.length;
    };

    handleChangeLocale = event => {
        const fetchBundle = this.props.bundleList[ event.locale.code ];

        if ( !fetchBundle ) {
            this.props.fetchBundleData( event.locale.code, true );
        } else {
            this.props.setUserLocale( event.locale.code );
        }
    };

    render() {
        const {
            oldPassword,
            newPassword
        } = this.state;

        const {
            passwordChangeSuccess,
            passwordRules,
            passwordLabels,
            passwordRequirements,
            localeOptions,
            locale,
            changePwdErrors,
            busyChangingPassword,
            changePwdSuccessMessage,
            changeLocaleSuccessMessage,
            changeLocaleErrors,
            dismissError,
            dismissSuccess,
            hidePasswordFields,
            user: {
                userName,
                emailAddress,
                firstName,
                lastName,
                adminAsUser
            }
        } = this.props;

        const pwdDescribedByErrors = describedByString( changePwdErrors, 'pwdError' );
        const localeDescribedByErrors = describedByString( changeLocaleErrors, 'localeError' );

        return (
            <div className="profile content-container">

                <div className="title" >
                    <Back className="back">
                        <CloseCircleIcon />
                    </Back>
                    <h1>
                        <LocaleString code="profile.page.header" />
                    </h1>
                </div>

                <div className="user-details narrow-form">
                    <h3><LocaleString code="profile.page.userDetailsHeader" /></h3>

                    <span className="label">
                        <LocaleString code="common.input.nameLabel" />
                    </span>
                    <p>{ `${firstName} ${lastName}` }</p>

                    <span className="label">
                        <LocaleString code="common.input.usernameLabel" />
                    </span>
                    <p>{ userName }</p>

                    <span className="label">
                        <LocaleString code="profile.input.emailLabel" />
                    </span>
                    <p>{ emailAddress }</p>

                    <hr/>

                </div>

                <div className="update-password narrow-form">

                    <div className="language-selector">
                        {
                            localeOptions.length > 1 &&
                            <div aria-describedby={ localeDescribedByErrors }>
                                <label htmlFor="language" key="languageSelectorLabel">
                                    <h3><LocaleString code="login.input.languageLabel" /></h3>
                                </label>
                                <LanguageSelector
                                    id="language"
                                    key="languageSelectorMenu"
                                    options = { localeOptions }
                                    selectedLocale={ locale }
                                    onClick={ this.handleChangeLocale }
                                    selectRef={ el => this.langSelect = el } />
                            </div>
                        }

                        {
                            changeLocaleErrors.length !== 0 && changeLocaleErrors.map( ( error, index ) => {
                                return (
                                    <Alert
                                        type={ 'error' }
                                        onDismiss={ () => dismissError( error ) }
                                        id={ `localeError${index}` }
                                        key={ index }>
                                        <p>{ error.responseMessage }</p>
                                    </Alert>
                                );
                            } )
                        }

                        {
                            changeLocaleSuccessMessage.length !== 0 &&
                            <Alert type={ 'success' } onDismiss={ () => dismissSuccess( changeLocaleSuccessMessage ) }>
                                <p><LocaleString code={ changeLocaleSuccessMessage[ 0 ].message } /></p>
                            </Alert>
                        }
                    </div>

                { // If the client is configured to be SSO only, hide the password update field
                    !hidePasswordFields &&
                    <div className="pwd-change-form">
                        { localeOptions.length > 1 && <hr/> }

                        <h3><LocaleString code="profile.page.passwordHeader" /></h3>

                        <div aria-describedby={ pwdDescribedByErrors } >
                            <PasswordInput
                                id="oldPassword"
                                label={ <LocaleString code="profile.input.oldPasswordLabel" /> }
                                name="oldPassword"
                                value={ oldPassword }
                                onChange={ this.handleInputChange }
                                onKeyPress={ this.checkEnter }
                            />

                            <PasswordHelper
                                id="newPassword"
                                label={ <LocaleString code="resetPassword.input.newPasswordLabel" /> }
                                name= "newPassword"
                                value= { newPassword }
                                onChange={ this.handleInputChange }
                                passwordRules={ passwordRules }
                                passwordLabels={ passwordLabels }
                                passwordRequirements={ passwordRequirements } />
                        </div>

                        {
                            changePwdErrors.length !== 0 && changePwdErrors.map( ( error, index ) => {
                                return (
                                    <Alert
                                        type={ 'error' }
                                        onDismiss={ () => dismissError( error ) }
                                        id={ `pwdError${index}` }
                                        key={ index }>
                                        <p>{ error.responseMessage }</p>
                                    </Alert>
                                );
                            } )
                        }

                        {
                            changePwdSuccessMessage.length !== 0 &&
                            <Alert type={ 'success' } onDismiss={ () => dismissSuccess( changePwdSuccessMessage ) }>
                                <p><LocaleString code={ changePwdSuccessMessage[ 0 ].message } /></p>
                            </Alert>
                        }

                        <LoaderButton
                            busy={ busyChangingPassword }
                            onClick={ () => this.handleChangePassword( oldPassword, newPassword ) }
                            disabled={ !this.validatePasswordFields() || !!adminAsUser }
                            done={ ( passwordChangeSuccess ? true : false ) }>
                            <LocaleString code="profile.button.submitLabel" />
                        </LoaderButton>
                    </div>
                /* END Password update section */}

                </div>

            </div>
        );
    }
}

export default Profile;
